import './HomeProjectPreviewStyles.css';

import React from 'react'
import { MdComputer, MdDesignServices } from 'react-icons/md';
import { FaMusic, FaPaintBrush } from 'react-icons/fa';

const HomeProjectPreview = () => {
  return (
    <div className='specialtyContainer'>
      <div className='specialSkills' id='developer'>
        <MdComputer size={40} className='icon'/>
        <h4 className='specialTitle'>
          Developer
        </h4>
        <p className='specialDetails'>
          I work with various languages and technologies to create websites and applications. Languages and frameworks I use include HTML, CSS, Javascript, React, JUCE and C++.
        </p>
      </div>
      <div className='specialSkills' id='design'>
        <MdDesignServices size={40} className='icon'/>
        <h4 className='specialTitle'>
          Designer
        </h4>
        <p className='specialDetails'>
          I have a high attention to detail and natural eye for creative visual designs with experience across a wide array of industries. Including graphic design, lighting, web, animation, and UX.
        </p>
      </div>
      <div className='specialSkills' id='art'>
        <FaPaintBrush size={40} className='icon'/>
        <h4 className='specialTitle'>
          Artist
        </h4>
        <p className='specialDetails'>
          I enjoy working in a variety of mediums including painting, sculpture, animation, 2D mediums, and mixed medias.
        </p>
      </div>
      <div className='specialSkills'>
        <FaMusic size={40} className='icon'/>
        <h4 className='specialTitle'>
          Musician
        </h4>
        <p className='specialDetails'>
          I also produce electronic and ambient music using an array of instruments and synthesizers.
        </p>
      </div>
    </div>
  )
}

export default HomeProjectPreview